import { FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { FormikOnSubmit } from "src/utils/types"
import { IStandardAddFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	handleSubmit: FormikOnSubmit<IStandardAddFormFields>
}

export const StandardAddDrawerFormView: FC<Props> = ({ handleSubmit, ...rest }) => (
	<Formik<IStandardAddFormFields>
		initialValues={{ name: "", semester: "" }}
		onSubmit={handleSubmit}
		enableReinitialize
	>
		{({ isSubmitting, handleChange }) => (
			<DrawerForm
				size="sm"
				headerLabel="Add Standard"
				submitLabel="Save"
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"}>
					{/* Name */}
					<FormControl>
						<InputLabel label="Standard Name" />
						<Input
							name="name"
							placeholder="Name"
							maxLength={100}
							required
							autoFocus
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="name" />
					</FormControl>
					{/* Semester */}
					<FormControl>
						<InputLabel label="Semester" />
						<Input
							name="semester"
							placeholder="Semester"
							maxLength={100}
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="semester" />
					</FormControl>
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
